// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	hmr: false,
	domainHint: 'dev.waldenu.edu',
	authService: 'microsoft.com',
	tenandId: 'a744b2fc-9cb1-4d03-8ea8-91043d5e1e66',
	cloudFunctionBaseUrl: 'https://us-central1-walden-clr-dev.cloudfunctions.net/walden/',
	firebase: {
		apiKey: "AIzaSyAyaLFfXq1KX7dQYkVw6TKDG_2x_kwuIzM",
	    authDomain: "walden-clr-dev.firebaseapp.com",
	    databaseURL: "https://walden-clr-dev.firebaseio.com",
	    projectId: "walden-clr-dev",
	    storageBucket: "walden-clr-dev.appspot.com",
	    messagingSenderId: "141284606754",
	    appId: "1:141284606754:web:4a92bba9974b266d"
	},
	hash: {
		isFixedSalt : false
	},
	CLRShare : {
		clrUrl : 'https://dev-myrecord.waldenu.edu/',
		profileUrl : 'myprofile/',
		indicator : 'clr/',
		expiryDate : 60
	},
	waldenTempoUrl : 'https://mytempo.waldenu.edu/MyProgress'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
